import React, { useState } from "react";
import { Search } from "lucide-react";

interface UnifiedSearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  helpText?: string;
  width?: number | string;
}

const UnifiedSearchBox: React.FC<UnifiedSearchBoxProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  helpText,
  width = 220,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const showHelp = Boolean(helpText && (isHovered || isFocused));

  return (
    <div
      style={{ position: "relative", flexShrink: 0, width }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Search
        size={15}
        style={{
          position: "absolute",
          left: 11,
          top: "50%",
          transform: "translateY(-50%)",
          color: "#2563eb",
          pointerEvents: "none",
        }}
      />
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(event) => onChange(event.target.value)}
        onFocus={(event) => {
          setIsFocused(true);
          event.currentTarget.style.borderColor = "#2563eb";
          event.currentTarget.style.boxShadow = "0 0 0 3px rgba(37,99,235,0.10)";
        }}
        onBlur={(event) => {
          setIsFocused(false);
          event.currentTarget.style.borderColor = "#cbd5e1";
          event.currentTarget.style.boxShadow = "none";
        }}
        style={{
          width: "100%",
          height: 38,
          boxSizing: "border-box",
          border: "1px solid #cbd5e1",
          borderRadius: 10,
          background: "#ffffff",
          padding: "8px 12px 8px 34px",
          color: "#1e293b",
          fontSize: 13,
          outline: "none",
          transition: "border-color 0.2s, box-shadow 0.2s",
        }}
      />

      {showHelp && (
        <div
          role="tooltip"
          style={{
            position: "absolute",
            top: "calc(100% + 9px)",
            left: 0,
            zIndex: 100,
            width: 360,
            maxWidth: "min(360px, calc(100vw - 32px))",
            padding: "11px 14px",
            borderRadius: 10,
            background: "#0f172a",
            color: "#ffffff",
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.55,
            boxShadow: "0 10px 28px rgba(15,23,42,0.24)",
            pointerEvents: "none",
          }}
        >
          <span
            aria-hidden="true"
            style={{
              position: "absolute",
              top: -5,
              left: 18,
              width: 10,
              height: 10,
              background: "#0f172a",
              transform: "rotate(45deg)",
            }}
          />
          <span style={{ position: "relative", zIndex: 1 }}>{helpText}</span>
        </div>
      )}
    </div>
  );
};

export default UnifiedSearchBox;
